import {
    createSimpleListComponent,
    SimpleList,
} from '@vfde-brix/simple-list';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/core';

const mountSimpleList = (container: HTMLElement, data: string[]): SimpleList => {
    const deliveryScopeItems = [];

    for (const item of data) {
        deliveryScopeItems.push({
            txtContent: item.trim(),
        });
    }

    const simpleList = createSimpleListComponent(container, {
        items: deliveryScopeItems,
        optType: 'bullet',
        business: NO_PATTERN_BUSINESS_LOGIC,
    });

    return simpleList;
};

export default mountSimpleList;
